import SectionLabel from '../common/SectionLabel';
import { formatPercent } from '../../utils/formatting';

function BenchmarkBar({ label, actual, target, lowerIsBetter = false }) {
  const pctOfTarget = Math.min((actual / target) * 100, 150);
  const isMet = lowerIsBetter ? actual <= target : actual >= target;
  const barColor = isMet ? 'bg-deep-teal' : 'bg-rose';

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-1">
        <span className="text-[13px] font-bold text-navy">{label}</span>
        <span className="text-[13px]">
          <span className={isMet ? 'text-deep-teal' : 'text-rose'}>
            {formatPercent(actual)}
          </span>
          <span className="text-[#888] ml-1">/ {formatPercent(target)} target</span>
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-[4px] h-3 relative">
        <div
          className={`${barColor} h-3 rounded-[4px] transition-all duration-500`}
          style={{ width: `${Math.min(pctOfTarget, 100)}%` }}
        />
        {/* Target line marker */}
        <div
          className="absolute top-0 h-3 w-0.5 bg-navy"
          style={{ left: `${Math.min((target / Math.max(actual, target) / 1) * 100, 100)}%` }}
        />
      </div>
    </div>
  );
}

export default function BenchmarkBars({ annualSummary, targets }) {
  const current2026 = annualSummary.find(d => d.year === 2026);
  if (!current2026) return null;

  // Gross Profit % = (Revenue - COGS) / Revenue
  const gpActual = (current2026.revenue - current2026.total_cogs) / current2026.revenue;
  // Expense % = Expenses / Revenue
  const epActual = current2026.total_expenses / current2026.revenue;
  // Net Profit % = Net Income / Revenue
  const npActual = current2026.net_income / current2026.revenue;

  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-5 mb-6">
      <SectionLabel>Financial Benchmarks</SectionLabel>
      <BenchmarkBar
        label="Gross Profit %"
        actual={gpActual}
        target={targets.gross_profit_pct}
      />
      <BenchmarkBar
        label="Operating Expense %"
        actual={epActual}
        target={targets.operating_expense_pct}
        lowerIsBetter
      />
      <BenchmarkBar
        label="Net Profit %"
        actual={npActual}
        target={targets.net_profit_pct}
      />
    </div>
  );
}
